import { Input } from "antd";
import { FiSearch } from "react-icons/fi";

const SearchWithButton = ({
  placeholder = "Search...",
  searchTerm,
  setSearchTerm,
  buttonLabel = "Add",
  onButtonClick,
}) => {
  return (
    <div className="flex items-center gap-2">
      <Input
        size="middle"
        placeholder={placeholder}
        prefix={<FiSearch className="text-gray-400" />}
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        allowClear
      />
      <button
        onClick={onButtonClick}
        className="bg-primary  text-white text-sm px-4 py-2 rounded-md  transition hover:bg-primary/90 cursor-pointer whitespace-nowrap"
      >
        {buttonLabel}
      </button>
    </div>
  );
};

export default SearchWithButton;
